module.exports = __webpack_public_path__ + "media/images/svg-icon/ecommerce-3b4053a389077255883e8f8f446cd12d.svg";